<template>
  <div v-if="options" class="site-header sticky">
    <div class="container grid-x h-100">
      <div class="cell small-3 h-100">
        <logo-header :options="options" class="h-100" />
      </div>
      <div :class="{ small: !large, large: large }" class="function-menu-container h-100">
        <function-menu :options="options" />
      </div>
    </div>
    <top-menu-mobile :options="options" />
  </div>
</template>
<script>
import FunctionMenu from '../FunctionMenu.vue';
import HeaderBaseMixinVue from '../HeaderBaseMixin.vue';
import LogoHeader from '../LogoHeader.vue';
import TopMenuMobileVue from './TopMenuMobile.vue';
import { hasProperty } from '@/common/Util/utility';

export default {
  name: 'SiteHeaderSmallScreen',
  components: {
    'logo-header': LogoHeader,
    'function-menu': FunctionMenu,
    'top-menu-mobile': TopMenuMobileVue
  },
  mixins: [HeaderBaseMixinVue],
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      leftContainerClasses: 'grid-y',
      topMenuClasses: '',
      hideTopMenu: true,
      stickyOverlay: ''
    };
  },
  computed: {
    logoOptions() {
      return {
        IsExperienceEditor: this.options.IsExperienceEditor,
        LogoLink: this.options.LogoLink,
        LogoFullscreenLargeImage: this.options.LogoMobileImage,
        LogoFullscreenOnScrollImage: this.options.LogoFullscreenOnScrollImage,
        LogoMobileImage: this.options.LogoMobileImage
      };
    },
    topMenuOptions() {
      return {
        BecomeMemberLink: this.options.BecomeMemberLink
      };
    },
    sizeClass() {
      return this.$store.state.header.ScrollY !== 0 ? 'site-header-small' : 'site-header-large';
    },
    headerHeight() {
      return {
        height: `${this.$store.state.header.height}px`
      };
    },
    topMenuStyle() {
      return {
        transition: `translate(${10}px, 20px)`
      };
    }
  },
  watch: {
    '$store.state.header.height': function () {
      this.hideTopMenu = false;

      setTimeout(() => {
        this.hideTopMenu = true;
      }, 400);
    },
    '$store.state.header.showMobileMenu': function (val) {
      if (hasProperty(this.$root.$refs, 'alert')) {
        if (val) {
          this.$root.$refs.alert.classList.add('hide');
        } else {
          this.$root.$refs.alert.classList.remove('hide');
        }
      }
    }
  },
  created() {},
  updated() {
    if (this.$parent && this.$parent.$el) {
      this.stickyOverlay = `height: ${this.$parent.$el.clientHeight}px`;
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
@import '../header';

.container {
  &.transition {
  }
}

.site-header {
  height: $header-height-mobile;
}

// .sticky {
//     position: sticky;
//     top: 0;
// }

.h-100 {
  height: 100%;
}

.padding-bottom {
  padding-bottom: $header-gutter-bottom;
}

.padding-top {
  padding-top: $header-gutter-bottom;
}

.sticky-overlay {
  height: 100vh;
}

.function-menu-container {
  position: absolute;

  right: $container-gutter-mobile;
}

.unscrolled-top-menu {
  position: absolute;
  bottom: 0;
  right: $container-gutter;
}

.fade-enter-active {
  transition: opacity 0.2s;
}
.fade-enter  /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

// .fade-leave-active {

//     transition: all 3s ease;
// }
// .fade-leave-to {
//      transform: translateX(10px);
// }
</style>
